import React from 'react'
import OpenInNewTabIcon from 'transfix-icons/build/OpenInNewTabIcon'
import { Button } from 'transfix-ui/components/Button'
import { Grid, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { IIssueAutomationRuleFragment } from '../../../automation/graphql/IssueAutomationRuleFragment'
import { AutomatedRuleRow } from './AutomatedRuleRow'

const useAutomatedRulesSectionStyles = makeStyles(theme => ({
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
  },
  tableHeader: {
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${brandColors.coolGray4}`,
  },
  emptyState: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& > p': {
      padding: 0,
    },
  },
}))

interface IAutomatedRulesSectionProps {
  /**
   * Id of issue type
   */
  id: number
  rules: IIssueAutomationRuleFragment[]
}

const AutomatedRulesSection = ({ id, rules }: IAutomatedRulesSectionProps) => {
  const classes = useAutomatedRulesSectionStyles()
  return (
    <div>
      <div className={classes.sectionHeader}>
        <Typography variant='body1'>Automated Rules</Typography>
        <Button
          startIcon={<OpenInNewTabIcon size='large' />}
          color='tertiary'
          href={`${__ROOT__}/issues/${id}/automation`}
          target='_blank'
          rel='noopener noreferrer'>
          Manage Rules
        </Button>
      </div>

      <div className={classes.table}>
        <Grid container className={classes.tableHeader}>
          <Grid item xs={6}>
            <Typography color='textSecondary' variant='subtitle2'>
              Name
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography color='textSecondary' variant='subtitle2'>
              Type
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography color='textSecondary' variant='subtitle2'>
              Last updated by
            </Typography>
          </Grid>
        </Grid>
        {rules.length > 0 && (
          <Grid container>
            {rules.map(rule => (
              <AutomatedRuleRow rule={rule} key={rule.id} issueTypeId={id} />
            ))}
          </Grid>
        )}
      </div>

      {!rules?.length && (
        <div className={classes.emptyState}>
          <Typography>No Rules Found</Typography>
          <Typography variant='body2'>
            Click{' '}
            <Button
              variant='text'
              noPadding
              href={`${__ROOT__}/issues/${id}/automation`}
              target='_blank'
              rel='noopener noreferrer'>
              Manage Rules
            </Button>{' '}
            to create rules for this issue type
          </Typography>
        </div>
      )}
    </div>
  )
}

export default AutomatedRulesSection
